
export  const DATA_COMES_FROM = {
     CONTACT_FORM : "CONTACT_FORM",
     CHECKOUT_FORM : "CHECKOUT_FORM",
     CANCEL_SERVICE_FORM : 'CANCEL_SERVICE_FORM'
}